/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */

export * from './models';
export * from './features/comparison/comparisonEngine';
export * from './features/window';
export * from './domain';
export * from './features/comparison';
export * from './features/threshold';
export * from './features/status';
export * from './features/metricValue';
export * from './features/warehousing';
export * from './formatting/subtitles';
export * from './formatting/comparisonText';
export { mapRolesToValues, getLatestValue, getComparisonDateRange } from './engine';
export { getDateRange, getUnitsInSeconds, getUnitsInMinutes, getUnitsinHours } from './dateUtils';
export { HitMaps, calculateHitMaps } from './hitMapCalculator';
export {
  formatAbsoluteValue,
  formatPillValue,
  formatValueAsMetricNumber,
  formatValueAsRelativeNumber,
  formatValueAsRelativePercentage,
  formatValueAsUnsignedPercentage,
} from './formatting/numberFormatter';
export { formatComparisonTextForDetail, formatComparisonTextForCard } from './formatting/deltaFormatter';
export { setEngineLocale } from './localization';
export {
  abbreviatedRelativeDateWindow,
  DateFormatterCollection,
  dateFormatterFactory,
  dateISOStringWithoutTimezone,
  lastRefreshedAbsoluteFormatter,
  windowPickerStartDate,
} from './formatting/dateFormatter';
export { DataPointsApiResponse, parseDataPoints, parseResponse, validDateOrUndefined } from './parseDataPoints';
export { symbolForDelta } from './formatting/symbolForDelta';
export { isPercentageFormat, maxPrecision } from './formatting/formatParser';
export { materializeTable } from './transforms/materializeTable';
export {
  getWarehousedDefinitionWithDayConfig,
  testEffectiveDefinition,
  testSingleNumberEffectiveDefinition,
} from './utils';
export { DefinitionBuilder, simpleDefinition } from './DefinitionBuilder';
export { DataPointsQuery } from './transforms/DataPointsQuery';
export * from './features/threshold/extendThroughRightMargin';
export * from './componentModels/CardModel';
export * from './componentModels/StatusIndicatorBarModel';
export * from './componentModels/FeatureFlags';
export {
  buildConfigurationText,
  MetricConfig,
  ConfigurationText,
  getConfigurationFromDefinition,
  definitionFromConfig,
} from './componentModels/Configuration';
export {
  isValueWithinRange,
  isValidConstantComparison,
  isValidRelativeDateRangeInput,
  isValidHistoricalComparisonInput,
  isValidConfiguration,
  MINIMUM_COMPARISON_VALUE,
  MAXIMUM_COMPARISON_VALUE,
  MINIMUM_RELATIVE_UNITS,
  MAXIMUM_RELATIVE_UNITS,
} from './validation';
